/**
 * router item各字段意义
 * {
 *  name: XXX  // 名字：用于侧边栏、面包屑
 *  path： XXX  // 路由地址，若没有则是一组路由的组，主要显示在侧边栏的分类中
 *  hideInMenu： true/false  // 是否显示在侧边栏中
 *  children: []  // 子路由组
 *  icon: string  // icon
 *  component：Conmponent // 组件
 * }
 *
 *
 */
import { routerConfig as managerRouterConfig } from '@/routes/manager.jsx'
import { routerConfig as dashboardRouterConfig } from '@/routes/dashboard.jsx'
import { routerConfig as policyRouterConfig } from '@/routes/policy.jsx'
import { routerConfig as monitorRouterConfig } from '@/routes/monitor.jsx'

const routerConfig = [
  {
    name: '登录页',
    path: '/login',
    hideInMenu: true
  },
  {
    name: '错误页',
    path: '/error',
    hideInMenu: true
  },
  {
    name: '首页',
    icon: 'home',
    children: dashboardRouterConfig
  },
  {
    name: '内容检测',
    icon: 'file-protect',
    children: managerRouterConfig
  },
  {
    name: '风控策略管理',
    icon: 'control',
    children: policyRouterConfig
  },
  {
    name: '监控管理',
    icon: 'alert',
    children: monitorRouterConfig
  }
]

export const BreadRouter = [
  {
    name: '内容检测',
    children: [
      {
        name: '设置管理',
        children: [
          {
            name: '词库管理',
            path: '/manager/thesaurus',
            children: [
              {
                name: '黑词文本管理',
                path: '/manager/thesaurus/words/:id'
              }
            ]
          },
          {
            name: '网址/域名/IP管理',
            path: '/manager/website'
          }
        ]
      },
      {
        name: '数据统计',
        children: [
          {
            name: '接口数据统计',
            path: '/manager/statistic/interface'
          },
          {
            name: '违规数据明细',
            path: '/manager/statistic/against-list'
          },
          {
            name: '风控拦截数据',
            path: '/manager/statistic/against-data'
          },
          {
            name: '内容审核',
            path: '/manager/statistic/content-review'
          },
        ]
      }
    ]
  },
  {
    name: '首页',
    children: [
      {
        name: '账户设置',
        children: [{ name: '账户基本资料', path: '/dashboard/user' }]
      },
      {
        name: '数据统计',
        path: '/dashboard/index'
      }
    ]
  },
  {
    name: '风控策略管理',
    children: [
      {
        name: '策略管理',
        children: [
          {
            name: '策略列表',
            path: '/policy/product',
            children: [
              {
                name: '策略详情',
                path: '/policy/product/:id'
              }
            ],
          },
          {
            name: '白名单',
            path: '/policy/whiteList',
          },
        ]
      },
      {
        name: '客户策略设置',
        children: [
          {
            name: '客户列表',
            path: '/policy/customer',
            children: [
              {
                name: '客户策略',
                path: '/policy/customer/:id'
              }
            ]
          },
          {
            name: '风险客户监控',
            path: '/policy/monitor'
          }
        ]
      }
    ]
  },
  {
    name: '监控管理',
    children: [
      {
        name: '审计日志列表',
        path: '/monitor/blog'
      },
      {
        name: '客户监控告警',
        path: '/monitor/alert'
      },
      {
        name: '夜间监控数据',
        path: '/monitor/night'
      },
    ]
  }
]

export default routerConfig
